import app from '@/store/app.js'
import api from '@/store/api.js'
import page from '@/store/page.js'

import contents from '@/store/contents.js'
import trashZumen from '@/store/trashZumen.js'
import itemKeys from '@/store/itemKeys.js'
import versionChecks from '@/store/versionChecks.js'
import binaryRevisionChecker from '@/store/binaryRevisionChecker.js'
import constructionRoles from '@/store/constructionRoles.js'
import accountPlans from '@/store/accountPlans.js'
import accountWarnings from '@/store/accountWarnings.js'
import report from '@/store/report.js'
import externalTransition from '@/store/externalTransition.js'
import batchDownloadPhoto from '@/store/batchDownloadPhoto.js'
import licenseInput from '@/store/licenseInput.js'
import premiumExpiringNotifications from '@/store/premiumExpiringNotifications.js'
import finalAccountRegistrations from '@/store/finalAccountRegistrations.js'
import banners from '@/store/banners.js'
import amnimo from '@/store/amnimo.js'

import createPersistedState from "vuex-persistedstate";
import { createStore } from 'vuex'

const store = createStore({
  modules: {
    app,
    api,
    page,
    report,
    contents,
    trashZumen,
    itemKeys,
    versionChecks,
    binaryRevisionChecker,    
    constructionRoles,
    accountPlans,
    accountWarnings,
    externalTransition,
    batchDownloadPhoto,
    licenseInput,
    premiumExpiringNotifications,
    finalAccountRegistrations,
    banners,
    amnimo,
  },
  plugins: [
    createPersistedState({
      key: 'KuraemonCloud2',
      paths: [
        'page.searchHistoryMap_v1',
        'premiumExpiringNotifications.lastNotifiedDates_v1',
        'accountWarnings.closedAccountWarnings_v1',
      ],
      storage: window.localStorage
    }),
    createPersistedState({
      key: 'KuraemonCloud2',
      paths: [
        'page.kokubanReverseFlg',
        'api.result.accountInfo',
        'photoEditor.capturedParams',
      ],
      storage: window.sessionStorage
    }),
  ]
})
export default store